import qs from 'qs'

export default {
    namespaced: true,
    state: {
        history: {},
        invoice: {}
    },
    mutations: {
        set_history(state, history) {
            state.history = history;
        }
    },
    actions: {
        async user_history({commit, state}) {
            let parameters = {
                action: 'user_order_history',
                security: window.global.ajax_nonce,
            }
            await this.axios.post(window.global.ajax, qs.stringify(parameters), {withCredentials: true}).then((res) => {
                commit('set_history', res.data.history);
            }).catch((e) => {
                console.log('error')
            })
        },
        async order_invoice({commit, state}, order_id) {
            let parameters = {
                action: 'getInvoice',
                orderId: order_id,
                security: window.global.ajax_nonce,
            }
            await this.axios.post(window.global.ajax, qs.stringify(parameters), {withCredentials: true}).then((res) => {
                // commit('set_history', res.data.history);
            }).catch((e) => {
                console.log('error')
            })
        },
    },
    getters: {
        get_history: (state) => state.history,
    }
};